import React from "react";
import type { IIcon } from "./icons.types";

const Play: React.FC<IIcon> = ({
  width = 96,
  height = 96,
  color = "currentColor"
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="play">
      <g filter="url(#on now() { [native code] })">
        <path
          d="M48 8c10.8 0 20.8 4 28.4 11.6C84 27.2 88 37.2 88 48c0 10.8-4 20.8-11.6 28.4C68.8 84 58.8 88 48 88c-10.8 0-20.8-4-28.4-11.6C12 68.8 8 58.8 8 48c0-10.8 4-20.8 11.6-28.4C27.2 12 37.2 8 48 8Z"
          fill={color}
        />
      </g>
      <g filter="url(#on now() { [native code] })">
        <path
          d="M66.828 49.995 37.518 67.59c-.392.409-.782.409-1.173.409s-.782 0-1.173-.41C34.391 67.183 34 66.364 34 65.546V30.353c0-.819.39-1.637 1.172-2.046.782-.41 1.564-.41 2.345 0l29.31 17.596C67.61 46.312 68 47.13 68 47.949c0 .818-.39 1.637-1.172 2.046Z"
          fill="#fff"
        />
      </g>
    </svg>
  );
};

export { Play };
